var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_4555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1831 14.725H31.6631V23.865H33.1831V14.725Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6631 23.865H30.1331V25.395H31.6631V23.865Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6631 13.1951H30.1331V14.7251H31.6631V13.1951Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1331 25.395H28.6131V28.435H30.1331V25.395Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1331 10.155H28.6131V13.195H30.1331V10.155Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0431 28.435V10.155H28.6131V8.62498H16.4221V7.10498H14.9021V8.62498H10.3231V7.10498H8.8031V8.62498H2.7121V10.155H22.5131V28.435H2.7121V29.965H28.6131V28.435H24.0431Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0931 23.865H25.5631V25.395H27.0931V23.865Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0931 20.8151H25.5631V22.3451H27.0931V20.8151Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0931 16.245H25.5631V17.775H27.0931V16.245Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0931 13.1951H25.5631V14.7251H27.0931V13.1951Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9421 2.53503H16.4221V4.05503H17.9421V2.53503Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4221 4.05505H14.9021V5.58505H16.4221V4.05505Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9031 5.58508H10.3231V7.10508H14.9031V5.58508Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3231 4.05505H8.8031V5.58505H10.3231V4.05505Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80308 2.53503H7.28308V4.05503H8.80308V2.53503Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4721 11.675H5.75012V13.195H4.23212V25.395H5.75012V26.915H19.4701V25.395H20.9901V13.195H19.4701L19.4721 11.675ZM13.3731 16.25H14.9021V17.78H13.3731V16.25ZM8.80312 16.25H10.3231V17.78H8.80312V16.25ZM16.4221 20.82H14.9021V22.35H8.80212V20.82H7.28312V19.3H8.80312V20.82H14.9031V19.3H16.4231L16.4221 20.82ZM19.4721 17.78H17.9421V14.73H14.9021V13.2H17.9421V14.73H19.4721V17.78Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71311 10.155H1.18311V28.435H2.71311V10.155Z",
    fill: "#000001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_4555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.850098 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.9d20b33fec195d77bf6ac1eacfe62318.svg";
export { ForwardRef as ReactComponent };